// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function Modal$Container(Props) {
  var children = Props.children;
  var hidden = Props.hidden;
  var active = hidden ? "opacity-0 pointer-events-none" : "opacity-1 pointer-events-auto";
  return React.createElement("div", {
              className: "\n        fixed w-full h-full top-0 left-0\n        flex items-center justify-center\n        " + active + "\n      ",
              style: {
                transition: "opacity 0.25s ease"
              }
            }, children);
}

var Container = {
  make: Modal$Container
};

function Modal(Props) {
  var children = Props.children;
  var hidden = Props.hidden;
  var onClose = Props.onClose;
  return React.createElement(Modal$Container, {
              children: null,
              hidden: hidden
            }, React.createElement("div", {
                  className: "absolute w-full h-full bg-gray-900 opacity-50",
                  onClick: onClose
                }), React.createElement("div", {
                  className: "bg-white w-11/12 md:max-w-md mx-auto rounded-2xl shadow-lg z-50 overflow-y-auto"
                }, React.createElement("div", {
                      className: "p-3 text-left"
                    }, children)));
}

var make = Modal;

export {
  Container ,
  make ,
  
}
/* react Not a pure module */
